export default __webpack_public_path__ + "static/media/contributions_help.f904d34c.jpg";